import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { AirValidationResponse } from '@app/entities/air-validation.response';
import { Countries } from '@ux/entities/country.enum';
import { SpecialInfoTypes } from '@booking/constants/special-info-types';
import { AssetTerm } from '@asset-terms';
import { SummaryTerms, TermsInterface } from '@app/entities/terms-and-conditions';
import { BOOKING_FORM_INPUTS } from '@booking/constants/forms.constants';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: 'terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})

export class TermsAndConditionsComponent implements OnInit {

  @Input() form: UntypedFormGroup;
  @Input() airValidation: AirValidationResponse;
  @Input() isSubmitted: boolean = false;
  @Input() policiesType: SearchBy;

  public readonly termsFormControlName = BOOKING_FORM_INPUTS.TERMS;
  public readonly extraTermsFormControlName = BOOKING_FORM_INPUTS.EXTRA_TERMS;
  public readonly civitatisTermsFormControlName = BOOKING_FORM_INPUTS.CIVITATIS_TERMS;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly countries = Countries;
  public readonly specialInfoTypes = SpecialInfoTypes;

  protected summaryTerms: SummaryTerms = AssetTerm.SUMMARY_TERMS_AND_POLICIES;

  protected formValidation: UntypedFormGroup;

  constructor() { }

  ngOnInit(): void {
    this.formValidation = this.form;
  }

  get isActivities(): boolean {
    return this.policiesType === SearchBy.ACTIVITIES && !this.civitatisPolicies.DISABLED;
  }

  get hasErrorInTerms(): boolean {
    return this.isSubmitted && (
      this.summaryTerms.INDIVIDUAL_TERMS ?
        this.isFieldValid(this.termsFormControlName) ||
        this.isFieldValid(this.extraTermsFormControlName) ||
        (this.isActivities && this.isFieldValid(this.civitatisTermsFormControlName)) :
        this.isFieldValid(this.termsFormControlName)
    );
  }

  get termsAndConditions(): TermsInterface {
    return this.summaryTerms.TERMS_AND_CONDITIONS;
  }

  get privacyPolicies(): TermsInterface {
    return this.summaryTerms.PRIVACY_POLICIES;
  }

  get treatmentPersonalPolicies(): TermsInterface {
    return this.summaryTerms.TREATMENT_PERSONAL_POLICIES;
  }

  get civitatisPolicies(): TermsInterface {
    return this.summaryTerms.CIVITATIS_POLICIES;
  }

  get campaignsTerms(): TermsInterface[] {
    return this.summaryTerms.CAMPAIGNS_TERMS?.filter(_c => !_c.DISABLED);
  }

  get hasCampaignsTerms(): boolean {
    return !!this.campaignsTerms?.length;
  }

  public trackById(index: number): number {
    return index;
  }

  public checkValue(control: string, checked: boolean): void {
    const value = checked ? true : null;
    this.form?.get(control)?.setValue(value);
    this.form?.updateValueAndValidity();
  }

  public addErrorClass(field: string): { [key: string]: boolean } {
    return this.displayFieldCss(field);
  }

  private isFieldValid(field: string): boolean {
    return this.formValidation && this.formValidation.get(field) ?
      !this.formValidation.get(field).valid && this.isSubmitted : false;
  }

  private displayFieldCss(field: string): { [key: string]: boolean } {
    return {
      error: this.isFieldValid(field)
    };
  }
}
